import QRCode from "qrcode";

/**
 * Genera un nodo pdfMake (canvas) con un QR a un tamaño EXACTO en px.
 *
 * El nodo `qr` nativo de pdfmake cuantiza el tamaño a múltiplos del número de
 * módulos (modSize = floor(fit / n)), por lo que solo permite saltos grandes
 * (sin tamaños intermedios) y el resultado cambia según el largo del contenido.
 * Dibujando los módulos con `canvas` controlamos el ancho de forma continua y
 * estable, sin importar el largo de la URL.
 *
 * @param {string} text   contenido del QR
 * @param {number} sizePx tamaño total del QR en px (incluye zona de silencio)
 * @param {object} [opts]
 * @param {number} [opts.quietZone=2] módulos de margen blanco alrededor
 * @param {string} [opts.dark="#000000"] color de los módulos
 * @param {"L"|"M"|"Q"|"H"} [opts.ecc="M"] nivel de corrección de error
 * @returns nodo pdfMake (canvas)
 */
export const qrCanvasNode = (text, sizePx, { quietZone = 2, dark = "#000000", ecc = "M" } = {}) => {
  const qr = QRCode.create(text, { errorCorrectionLevel: ecc });
  const n = qr.modules.size;
  const data = qr.modules.data;
  const total = n + quietZone * 2;
  const mod = sizePx / total;
  const cells = [
    // Fondo blanco que cubre el QR y su zona de silencio.
    { type: "rect", x: 0, y: 0, w: sizePx, h: sizePx, color: "#FFFFFF" },
  ];
  for (let r = 0; r < n; r++) {
    for (let c = 0; c < n; c++) {
      if (data[r * n + c]) {
        cells.push({
          type: "rect",
          x: (quietZone + c) * mod,
          y: (quietZone + r) * mod,
          w: mod,
          h: mod,
          color: dark,
        });
      }
    }
  }
  return { canvas: cells };
};

export default qrCanvasNode;
